module.exports = __webpack_public_path__ + "5a5de093e9e813001bdf03563d554ea9.png";